export default {
  mediaModalShown: false,
  datePickerShortcut: null,
  datePickerStartDate: null,
  datePickerEndDate: null,
  datePickerResolution: null,
  datePickerNumbersFilter: [],
};
